export default __webpack_public_path__ + "static/error-404-f0782f8e5764a6ad592da39f57011c9d.svg";